module.exports = __webpack_public_path__ + "static/media/Jeremy_J@3x.d134d015.jpg";